// src/frontend/data/books/BlockchainFundamentals/data/cap13.js

const CAP13 = {
  id: 13,
  slug: "cap13-tipos-de-criptomonedas",
  title: "Capítulo 13 — Bitcoin, Altcoins, Stablecoins, Memecoins y Native Coins",
  sections: [
    {
      heading: "El ecosistema de las criptomonedas",
      text: [
        "Con el paso de los años, el ecosistema cripto ha crecido y se ha diversificado enormemente.",
        "Hoy no existe ‘una sola’ criptomoneda, sino distintos tipos de activos digitales, cada uno con objetivos, reglas y diseños diferentes.",
        "Comprender estas categorías es clave para no confundir tecnología, narrativa y riesgo."
      ]
    },

    // ===== BITCOIN =====
    {
      heading: "Bitcoin: el origen de todo",
      text: [
        "Bitcoin fue la primera criptomoneda y la primera red blockchain funcional a gran escala.",
        "Su objetivo principal es ser un sistema monetario digital descentralizado, resistente a censura y con una política monetaria predecible.",
        "Bitcoin prioriza seguridad, descentralización y resistencia a ataques por encima de la velocidad o complejidad funcional."
      ]
    },
    {
      heading: "Características clave de Bitcoin",
      list: [
        "Primera generación de blockchain.",
        "Uso de Proof of Work (PoW).",
        "Suministro máximo fijo de 21 millones de BTC.",
        "No está diseñada para ejecutar aplicaciones complejas.",
        "Funciona principalmente como reserva de valor y sistema de pago."
      ]
    },

    // ===== ALTCOINS =====
    {
      heading: "Altcoins: todo lo que no es Bitcoin",
      text: [
        "El término altcoin (alternative coin) engloba a todas las criptomonedas distintas de Bitcoin.",
        "Las altcoins surgen para explorar ideas que Bitcoin no prioriza: velocidad, smart contracts, privacidad, interoperabilidad o escalabilidad.",
        "Cada altcoin refleja una decisión de diseño distinta."
      ]
    },
    {
      heading: "Ejemplos de altcoins y sus enfoques",
      list: [
        "Ethereum: smart contracts y aplicaciones descentralizadas.",
        "Solana: alta velocidad y ejecución paralela.",
        "Polkadot: interoperabilidad entre blockchains.",
        "Monero: privacidad por diseño.",
        "Hedera: rendimiento empresarial y DLT."
      ]
    },

    // ===== STABLECOINS =====
    {
      heading: "Stablecoins: estabilidad dentro del mundo cripto",
      text: [
        "Las stablecoins son criptomonedas diseñadas para mantener un valor estable, normalmente ligado a una moneda fiduciaria como el dólar.",
        "Nacen para resolver el problema de la alta volatilidad del mercado cripto.",
        "Permiten pagos, ahorro, trading y préstamos sin salir del ecosistema blockchain."
      ]
    },
    {
      heading: "Tipos de stablecoins",
      list: [
        "Centralizadas: respaldadas por reservas administradas por una empresa (ej. USDT, USDC).",
        "Descentralizadas: sostenidas por colateral y smart contracts (ej. DAI).",
        "Algorítmicas: intentan mantener estabilidad solo con incentivos y código (más riesgosas)."
      ]
    },

    // ===== MEMECOINS =====
    {
      heading: "Memecoins: cultura, comunidad y narrativa",
      text: [
        "Las memecoins son criptomonedas cuyo origen principal no es la innovación tecnológica, sino la cultura de Internet, los memes y la comunidad.",
        "Suelen nacer como bromas, sátiras o experimentos sociales, pero algunas alcanzan gran capitalización.",
        "Dogecoin es el ejemplo más famoso de este fenómeno."
      ]
    },
    {
      heading: "¿En qué redes viven las memecoins?",
      text: [
        "Las memecoins no suelen crear su propia blockchain.",
        "Generalmente existen como tokens dentro de redes ya establecidas.",
        "Esto reduce costos de desarrollo y aprovecha la infraestructura existente."
      ]
    },
    {
      heading: "Redes comunes para memecoins",
      list: [
        "Dogecoin: tiene su propia red (fork de Litecoin).",
        "Ethereum: muchas memecoins ERC-20.",
        "Binance Smart Chain (BSC): memecoins de bajo costo.",
        "Solana: memecoins de alta velocidad y bajo fee.",
        "Polygon: tokens meme con comisiones reducidas."
      ]
    },
    {
      heading: "Riesgos de las memecoins",
      text: [
        "Alta volatilidad extrema.",
        "Dependencia de narrativa y redes sociales.",
        "Pocos fundamentos técnicos.",
        "Riesgo elevado de estafas o abandono del proyecto."
      ]
    },

    // ===== NATIVE COINS =====
    {
      heading: "Native coins: el corazón de cada red",
      text: [
        "Una native coin es la criptomoneda principal de una blockchain.",
        "Es el activo que se usa para pagar comisiones, asegurar la red y coordinar incentivos económicos.",
        "Sin una native coin, la mayoría de blockchains no podría operar de forma segura."
      ]
    },
    {
      heading: "Ejemplos de native coins",
      list: [
        "Bitcoin → BTC",
        "Ethereum → ETH",
        "Solana → SOL",
        "Polygon → MATIC / POL",
        "Hedera → HBAR",
        "Polkadot → DOT"
      ]
    },
    {
      heading: "¿Por qué las native coins son así?",
      text: [
        "Las native coins existen para alinear incentivos entre usuarios, validadores y desarrolladores.",
        "Sirven como mecanismo económico para evitar spam, pagar recursos de red y castigar comportamientos maliciosos.",
        "Cada red diseña su native coin según su modelo de consenso (PoW, PoS, DAG, etc.)."
      ]
    },

    // ===== RELACIÓN ENTRE TODO =====
    {
      heading: "Cómo se relacionan todos estos tipos",
      text: [
        "Bitcoin establece la base como dinero digital descentralizado.",
        "Las altcoins exploran nuevas funciones y modelos.",
        "Las stablecoins aportan estabilidad dentro del sistema.",
        "Las memecoins muestran el poder de la cultura y la comunidad.",
        "Las native coins mantienen vivas y seguras a las redes."
      ]
    },

    // ===== CIERRE =====
    {
      heading: "Conclusión",
      text: [
        "El mundo cripto no es homogéneo: cada tipo de moneda cumple un rol distinto.",
        "Entender estas diferencias evita errores comunes como comparar proyectos con objetivos totalmente distintos.",
        "Bitcoin no compite directamente con memecoins; una stablecoin no cumple el mismo rol que una native coin.",
        "Tener criterio para distinguir estas categorías es una de las habilidades más importantes en el ecosistema cripto."
      ]
    }
  ]
};

export default CAP13;


